import React, { PureComponent } from 'react'
import { DatePicker } from 'material-ui-pickers'
import { TimePicker } from 'material-ui-pickers'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import StyleSheet from 'styles'
import { MuiThemeProvider, createMuiTheme, withTheme } from '@material-ui/core';
import TextField from '@material-ui/core/TextField'
import {deepMerge} from 'utils/CollectionUtils'

class DateTimePicker extends PureComponent {
  static propTypes = {
    showClear: PropTypes.bool.isRequired
  }

  static defaultProps = {
    showClear: true
  }

  get date() {
    return this.props.value ? this.formatDate(this.props.value) : ''
  }

  get time() {
    return this.props.value ? this.formatTime(this.props.value) : ''
  }

  get showDate() {
    return this.props.showDate || (!this.props.showDate && !this.props.showTime)
  }

  get showTime() {
    return this.props.showTime || (!this.props.showDate && !this.props.showTime)
  }

  get value() {
    return this.props.value ? this.toDate(moment(this.props.value).tz(this.timezone)) : null
  }

  get timezone() {
    return this.props.timezone || moment.tz.guess()
  }

  get defaultTime() {
    return moment(this.props.defaultTime || '00:00:00', 'HH:mm:ss').toDate()
  }

  get wrapperStyles() {
    if (this.showDate && this.showTime)
      return styles.dateTimeWrapper
    if (this.showDate)
      return styles.dateWrapper
    if (this.showTime)
      return styles.timeWrapper
    return undefined
  }

  get theme() {
    return this._theme || (this._theme = getTheme(this.props.theme))
  }

  toDate(moment) {
    return new Date(moment.year(), moment.month(), moment.date(), moment.hour(), moment.minute(), moment.second(), 0)
  }

  formatDate = (date) => {
    return date ? moment(date).format('YYYY-MM-DD') : ''
  }

  formatTime = (date) => {
    return date ? moment(date).format('h:mm a') : ''
  }

  handleDateChange = (date) => {
    let previous = moment(this.value || this.defaultTime)
    let newDate = moment.tz(moment(date).format('YYYY-MM-DD HH:mm:ss'), this.timezone)
    newDate.hours(previous.hours())
    newDate.minutes(previous.minutes())
    newDate.seconds(previous.seconds())
    const dateISO8601 = newDate.toISOString()
    this.props.onChange({target: {value: dateISO8601}}, dateISO8601)
  }

  handleError = () => {
    this.props.onChange({target: {value: null}}, null)
  }

  handleTimeChange = (date) => {
    const dateISO8601 = moment.tz(moment(date).format('YYYY-MM-DD HH:mm:ss'), this.timezone).toISOString()
    this.props.onChange({target: {value: dateISO8601}}, dateISO8601)
  }

  render = () => {
    const defaultTimeLabel = this.showDate ? ' ' : this.props.label
    const disabled = !!this.props.disabled

    return (
      <MuiThemeProvider theme={this.theme}>
        <div style={this.props.style} className={`${this.wrapperStyles} ${styles({root: true, disabled})} ${this.props.className}`}>
          {this.showDate && (
            this.props.disabled ?
              <TextField label={this.props.label} value={this.date}
                         className={styles.dateInput} margin={this.props.margin} disabled/>
              :
              <DatePicker
                label={this.props.label}
                id={`date-picker-${this.props.name}`}
                openToYearSelection={this.props.openToYearSelection}
                value={this.value || null}
                onChange={this.handleDateChange}
                onError={this.handleError}
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                className={styles.dateInput}
                margin={this.props.margin}
                required={this.props.required}
                error={this.props.error}
                helperText={this.props.helperText}
                keyboard
              />
            )
          }
          {this.showTime && (
            this.props.disabled ?
              <TextField label={this.props.timeLabel || defaultTimeLabel } value={this.date}
                         className={styles.dateInput} margin={this.props.margin} disabled/>
              :
              <TimePicker
                label={ this.props.timeLabel || defaultTimeLabel }
                id={`date-picker-${this.props.name}`}
                value={this.value}
                onChange={this.handleTimeChange}
                onError={this.handleError}
                className={styles.timeInput}
                margin={this.props.margin}
                placeholder="HH:MM PM"
                keyboardIcon="alarm"
                keyboard
              />
            )
          }
      </div>
      </MuiThemeProvider>
    )
  }
}

export default withTheme()(DateTimePicker)

const getTheme = theme => createMuiTheme(deepMerge(theme, {
  overrides: {
    MuiTypography: {
      subheading: {
        paddingTop: 0
      },
      body1: {
        marginTop: 0
      }
    },
    MuiInputAdornment: {
      positionEnd: {
        marginLeft: 0
      }
    },
    MuiPickersCalendarHeader: {
      iconButton: {
        backgroundColor: undefined,
        '& > *':{
          backgroundColor: undefined
        }
      }
    }
  },
}));

export const styles = StyleSheet({
  root: {
    verticalAlign: 'top',
    display: 'flex',
  },
  dateWrapper: {},
  dateTimeWrapper: {},
  timeWrapper: {},
  dateInput: {
    flex: 2,
  },
  timeInput: {
    flex: 1,
  },
  disabled: {
    paddingTop: 3
  },
  marginDense: {
    marginBottom: 4,
  }
})